import React from "react";

// plugin imports

// style imports
import "./BorderArrowButton.scss";

// component imports

// util imports

// svg imports
import Favicon from "../../svg/favicon.svg";

// component
export default function BorderArrowButton({ children }) {
	return (
		<div className="borderArrowContainer">
			{children}
			<div className="borderArrow" />
			<Favicon className="borderArrowIcon" />
		</div>
	);
}
